import {
  IOtherDetailFormValues,
  ITermTargetFormValues,
} from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { IInfoCategoryMasterData } from '@Domains/MasterData';

export const checkTermTargetComplete = (
  data: ITermTargetFormValues | undefined
): boolean => {
  if (!data) return false;
  const { year, gasEmissionQuantity, gasEmissionPercent } = data;
  const hasYear = Boolean(year);
  const hasTarget = Boolean(gasEmissionQuantity) || Boolean(gasEmissionPercent);
  return hasYear && hasTarget;
};

export const mapOtherGreenhouseGasFormValue = (
  data: IOtherDetailFormValues
): IOtherDetailFormValues => {
  return {
    ...data,
    baseYear: {
      ...data.baseYear,
      gasEmissionQuantity: data.baseYear?.gasEmissionQuantity
        ? String(data.baseYear.gasEmissionQuantity)
        : undefined,
    },
    nearTermTarget: {
      ...data.nearTermTarget,
      gasEmissionPercent: data.nearTermTarget.gasEmissionPercent
        ? String(data.nearTermTarget.gasEmissionPercent)
        : undefined,
      gasEmissionQuantity: data.nearTermTarget.gasEmissionQuantity
        ? String(data.nearTermTarget.gasEmissionQuantity)
        : undefined,
    },
    longTermTarget: {
      ...data.longTermTarget,
      gasEmissionPercent: data.longTermTarget.gasEmissionPercent
        ? String(data.longTermTarget.gasEmissionPercent)
        : undefined,
      gasEmissionQuantity: data.longTermTarget.gasEmissionQuantity
        ? String(data.longTermTarget.gasEmissionQuantity)
        : undefined,
    },
  };
};

export const isGoalYearComplete = (
  nearTermTarget: ITermTargetFormValues | undefined,
  longTermTarget: ITermTargetFormValues | undefined
): boolean => {
  return (
    checkTermTargetComplete(nearTermTarget) ||
    checkTermTargetComplete(longTermTarget)
  );
};

export const filterScopeOptions = (
  allScopes: IInfoCategoryMasterData[] | undefined,
  currentScopes: number[],
  editScopeId?: number
): IInfoCategoryMasterData[] => {
  return (
    allScopes?.filter((option) => {
      if (typeof option.id === 'number') {
        return !currentScopes.includes(option.id) || option.id === editScopeId;
      }
      return false;
    }) || []
  );
};
